var html = $('html');
var headerHeight = $('.hd').height();

jQuery(function ($) {
  ham();
  tab();
  megamenu();
  sideBarFilter();

  $(window).scroll(function () {
    isscroll();
  });

  $(window).on('load', function () {
    anchor();
  });
});

function ham() {
  var ham = $('#js-ham'),
    close = $('#js-close');

  ham.click(function () {
    $(html).toggleClass('is-active');
    if (!$(html).hasClass('is-active')) {
      $(html).removeClass('is-active');
    }
  });

  close.click(function () {
    $(html).toggleClass('is-active');
    if (!$(html).hasClass('is-active')) {
      $(html).removeClass('is-active');
    }
  });
}

function isscroll() {
  if ($(this).scrollTop() > 0) {
    if ($(this).scrollTop() >= headerHeight) {
      $(html).addClass('is-view');
    }
  } else {
    $(html).removeClass('is-view');
  }
}

function anchor() {
  $('a[href^="#"]').not('[href="#recover"], [href="#login"]').click(function () {
    var headerPosition = $('header').css('position'),
      headerHeight = $('header').height(),
      speed = 500,
      href = $(this).attr("href"),
      target = $(href == "#" || href == "" ? 'html' : href),
      position;

    if (headerPosition == 'fixed') {
      position = target.offset().top - headerHeight;
    } else {
      position = target.offset().top;
    }

    $("html, body").animate({
      scrollTop: position
    }, speed, "swing");

    return false;
  });
}

function tab() {
  $('[data-tab-content]').hide();

  $('[data-tab].active').each(function () {
    var initialTabId = $(this).data('tab');
    $('[data-tab-content="' + initialTabId + '"]').show();
  });

  $('[data-tab]').on('click', function () {
    var tabId = $(this).data('tab');

    $('[data-tab]').removeClass('active');
    $(this).addClass('active');
    $('[data-tab-content]').hide();
    $('[data-tab-content="' + tabId + '"]').fadeIn(300);
  });
}

function megamenu() {
  var $mainAnc = $('.js-mainMenuAnc');
  var $subAnc = $('.js-megaMenuAnc');
  var $normalAcc = $('.js-normalAccordion');
  var mqPc = window.matchMedia('(min-width: 1280px)');

  function openMegaSp($target) {
    $target
      .stop(true, true)
      .css({
        display: 'none',
        opacity: 0
      })
      .slideDown(420, 'swing')
      .animate(
        { opacity: 1 },
        {
          duration: 220,
          queue: false
        }
      );
  }

  function closeMegaSp($target) {
    $target
      .stop(true, true)
      .animate(
        { opacity: 0 },
        {
          duration: 160,
          queue: false
        }
      )
      .slideUp(360, 'swing');
  }

  function openSubSp($target) {
    $target
      .stop(true, true)
      .css({
        display: 'none',
        opacity: 0
      })
      .slideDown(280, 'swing')
      .animate(
        { opacity: 1 },
        {
          duration: 180,
          queue: false
        }
      );
  }

  function closeSubSp($target) {
    $target
      .stop(true, true)
      .animate(
        { opacity: 0 },
        {
          duration: 140,
          queue: false
        }
      )
      .slideUp(240, 'swing');
  }

  function openNormalSp($target) {
    $target
      .stop(true, true)
      .css({
        display: 'none',
        opacity: 0
      })
      .slideDown(280, 'swing')
      .animate(
        { opacity: 1 },
        {
          duration: 180,
          queue: false
        }
      );
  }

  function closeNormalSp($target) {
    $target
      .stop(true, true)
      .animate(
        { opacity: 0 },
        {
          duration: 140,
          queue: false
        }
      )
      .slideUp(240, 'swing');
  }

  function setDefaultAccordionOpen() {
    if (mqPc.matches) return;

    $('.-allitemlist .js-itemSearchSpToggle').addClass('open');
    $('.-allitemlist .js-itemSearchSpBody').show();

    $('.js-megaMenuSub').hide().css('opacity', 1);
    $('.js-normalAccordionBody').hide().css('opacity', 1);

    $('.js-normalAccordion.is-default-open').each(function () {
      $(this)
        .addClass('open')
        .next('.js-normalAccordionBody')
        .show()
        .css('opacity', 1);
    });
  }

  setDefaultAccordionOpen();

  $normalAcc.on('click', function (e) {
    if (mqPc.matches) return;

    e.preventDefault();

    var $this = $(this);
    var $target = $this.next('.js-normalAccordionBody');
    var isOpen = $this.hasClass('open');

    $('.js-normalAccordion').not($this).removeClass('open');
    $('.js-normalAccordionBody').not($target).each(function () {
      closeNormalSp($(this));
    });

    if (isOpen) {
      $this.removeClass('open');
      closeNormalSp($target);
    } else {
      $this.addClass('open');
      openNormalSp($target);
    }
  });

  $mainAnc.on('click', function (e) {
    var $this = $(this);
    var $parent = $this.closest('.mainMenu__item');
    var $target = $this.next('.js-megaMenu');
    var isPc = mqPc.matches;
    var isOpen = $this.hasClass('open');

    if (!$target.length) return;
    e.preventDefault();

    $parent.siblings('.mainMenu__item').each(function () {
      var $item = $(this);

      $item.find('.js-mainMenuAnc').removeClass('open');
      $item.find('.js-megaMenuAnc').removeClass('open');
      $item.find('.js-normalAccordion').removeClass('open');

      if (!isPc) {
        $item.find('.js-megaMenuSub').each(function () {
          closeSubSp($(this));
        });
        $item.find('.js-megaMenu').each(function () {
          closeMegaSp($(this));
        });
        $item.find('.js-normalAccordionBody').each(function () {
          closeNormalSp($(this));
        });
      } else {
        $item.find('.js-megaMenuSub').removeAttr('style');
        $item.find('.js-normalAccordionBody').removeAttr('style');
      }
    });

    if (isOpen) {
      $this.removeClass('open');
      $parent.find('.js-megaMenuAnc').removeClass('open');
      $parent.find('.js-normalAccordion').removeClass('open');

      if (!isPc) {
        $parent.find('.js-megaMenuSub').each(function () {
          closeSubSp($(this));
        });
        $parent.find('.js-normalAccordionBody').each(function () {
          closeNormalSp($(this));
        });
        closeMegaSp($target);
      } else {
        $parent.find('.js-megaMenuSub').removeAttr('style');
        $parent.find('.js-normalAccordionBody').removeAttr('style');
      }
    } else {
      $this.addClass('open');

      if (!isPc) {
        openMegaSp($target);
      }
    }
  });

  $subAnc.on('click', function (e) {
    var $this = $(this);
    var $parent = $this.closest('.megaMenu__item');
    var $target = $this.next('.js-megaMenuSub');
    var isPc = mqPc.matches;
    var isOpen = $this.hasClass('open');
    var hadOtherOpen = false;

    if (!$target.length) return;
    e.preventDefault();

    $parent.siblings('.megaMenu__item').each(function () {
      var $item = $(this);
      var $otherAnc = $item.find('.js-megaMenuAnc');
      var $otherSub = $item.find('.js-megaMenuSub');

      if ($otherAnc.hasClass('open')) {
        hadOtherOpen = true;
      }

      $otherAnc.removeClass('open');

      if (!isPc) {
        $otherSub.each(function () {
          closeSubSp($(this));
        });
      } else {
        $otherSub.removeAttr('style');
      }
    });

    if (isOpen) {
      $this.removeClass('open');

      if (!isPc) {
        closeSubSp($target);
      } else {
        $target.removeAttr('style');
      }
    } else {
      var openCurrent = function () {
        $this.addClass('open');

        if (!isPc) {
          openSubSp($target);
        }
      };

      if (hadOtherOpen) {
        setTimeout(openCurrent, isPc ? 260 : 220);
      } else {
        openCurrent();
      }
    }
  });

  $(document).on('click', function (e) {
    if (!$(e.target).closest('.mainMenu, .ham').length) {
      $('.js-mainMenuAnc').removeClass('open');
      $('.js-megaMenuAnc').removeClass('open');
      $('.js-normalAccordion').removeClass('open');

      if (!mqPc.matches) {
        $('.js-megaMenu').each(function () {
          closeMegaSp($(this));
        });
        $('.js-megaMenuSub').each(function () {
          closeSubSp($(this));
        });
        $('.js-normalAccordionBody').each(function () {
          closeNormalSp($(this));
        });
      } else {
        $('.js-megaMenuSub').removeAttr('style');
        $('.js-normalAccordionBody').removeAttr('style');
      }
    }
  });

  $('.mainMenu').on('click', function (e) {
    e.stopPropagation();
  });

  $('#js-ham').on('click', function () {
    setTimeout(function () {
      setDefaultAccordionOpen();
    }, 0);
  });

  $(window).on('resize', function () {
    if (mqPc.matches) {
      $('.js-megaMenu').removeAttr('style');
      $('.js-megaMenuSub').removeAttr('style');
      $('.js-normalAccordionBody').removeAttr('style');
    } else {
      $('.js-megaMenu').each(function () {
        var $mega = $(this);
        var $anc = $mega.prev('.js-mainMenuAnc');

        if ($anc.hasClass('open')) {
          $mega.show().css('opacity', 1);
        } else {
          $mega.hide().css('opacity', 1);
        }
      });

      $('.js-megaMenuSub').each(function () {
        var $sub = $(this);
        var $anc = $sub.prev('.js-megaMenuAnc');

        if ($anc.hasClass('open')) {
          $sub.show().css('opacity', 1);
        } else {
          $sub.hide().css('opacity', 1);
        }
      });

      $('.js-normalAccordionBody').each(function () {
        var $body = $(this);
        var $title = $body.prev('.js-normalAccordion');

        if ($title.hasClass('open')) {
          $body.show().css('opacity', 1);
        } else {
          $body.hide().css('opacity', 1);
        }
      });
    }
  });
}

function sideBarFilter() {
  $('.js-product-filter-btn').click(function () {
    $('.js-product-filter').fadeIn(100);
  });

  $('.js-product-filter-close').click(function () {
    $('.js-product-filter').fadeOut(100);
  });
}

// お買い物ガイドページアコーディオン処理
document.addEventListener("DOMContentLoaded", () => {
  const accordions = document.querySelectorAll(".itemContent__accordionGroup__ttl");

  accordions.forEach((accordionTtl) => {
    accordionTtl.addEventListener("click", function () {
      const parentWrap = this.closest(".itemContent__accordion");
      const content = this.nextElementSibling;

      parentWrap.classList.toggle("is-open");

      if (parentWrap.classList.contains("is-open")) {
        content.style.height = content.scrollHeight + "px";
      } else {
        content.style.height = content.scrollHeight + "px";
        content.offsetHeight;
        content.style.height = "0";
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const nav = document.getElementById('productsNav');
  const toggle = document.querySelector('.products__navToggle');

  if (!nav || !toggle) return;

  const overlay = document.createElement('div');
  overlay.className = 'products__navOverlay';
  document.body.appendChild(overlay);

  function openNav() {
    nav.classList.add('is-open');
    overlay.classList.add('is-open');
    toggle.classList.add('is-open');
    toggle.classList.remove('is-fade');
    document.body.classList.add('is-products-nav-open');
  }

  function closeNav() {
    nav.classList.remove('is-open');
    overlay.classList.remove('is-open');
    toggle.classList.remove('is-open');
    document.body.classList.remove('is-products-nav-open');
  }

  toggle.addEventListener('click', function () {
    if (nav.classList.contains('is-open')) {
      closeNav();
    } else {
      openNav();
    }
  });

  overlay.addEventListener('click', closeNav);

  window.addEventListener('resize', function () {
    if (window.innerWidth > 768) {
      closeNav();
    }
  });

  let scrollTimer = null;

  function navToggleScrollFadeWhileScrolling() {
    const toggle = document.querySelector('.products__navToggle');
    const nav = document.getElementById('productsNav');

    if (!toggle || !nav) return;

    if (nav.classList.contains('is-open')) {
      toggle.classList.remove('is-fade');
      return;
    }

    toggle.classList.add('is-fade');

    clearTimeout(scrollTimer);

    scrollTimer = setTimeout(() => {
      toggle.classList.remove('is-fade');
    }, 180);
  }

  window.addEventListener('scroll', navToggleScrollFadeWhileScrolling);
});

document.addEventListener('DOMContentLoaded', function () {
  const searchBtn = document.querySelector('.js-productsNavOpen');

  if (!searchBtn) return;

  searchBtn.addEventListener('click', function () {
    const filterBtn = document.querySelector('.products__navToggle');

    if (filterBtn) {
      filterBtn.click();
    } else {
      location.href = '/search';
    }
  });
});

$(function () {

  // 初期状態で開く
  if (window.innerWidth < 1280) {
    $('.-allitemlist .js-itemSearchSpToggle').addClass('open');
    $('.-allitemlist .js-itemSearchSpBody').show();
  }

  $('.js-itemSearchSpToggle').on('click', function (e) {
    if (window.innerWidth >= 1280) return;

    e.preventDefault();

    var $this = $(this);
    var $body = $this.next('.js-itemSearchSpBody');

    $this.toggleClass('open');

    $body
      .stop(true, true)
      .slideToggle(200, 'swing');
  });
});

(function () {
  const replaceStaffBoardText = () => {

    // スタイル一覧ページ：タイトル
    const styleListTitle = document.querySelector(
      '.pb-app-stylelist-title'
    );

    if (
      styleListTitle &&
      styleListTitle.textContent.trim() !== 'スタッフスタイル'
    ) {
      styleListTitle.textContent = 'スタッフスタイル';
    }

    // スタッフ詳細ページ：タイトル
    const staffDetailTitle = document.querySelector(
      '.pb-app-staffdetail-style-root h2'
    );

    if (
      staffDetailTitle &&
      staffDetailTitle.textContent.trim() !== 'スタッフスタイル'
    ) {
      staffDetailTitle.textContent = 'スタッフスタイル';
    }

    // タブ：「スタイリング」
    document
      .querySelectorAll('a[href="/apps/staffboard/coordinate"]')
      .forEach((tab) => {
        if (tab.textContent.trim() === 'スタイリング') {
          tab.textContent = 'スタッフスタイル';
        }
      });

    // パンくず
    document
      .querySelectorAll(
        '.pb-app-breadcrumb-layer-text, .pb-app-breadcrumb-layer'
      )
      .forEach((breadcrumb) => {
        const text = breadcrumb.textContent.trim();

        // 「スタイル一覧」
        if (text === 'スタイル一覧') {
          breadcrumb.textContent = 'スタッフスタイル一覧';
          return;
        }

        // 「〇〇のスタイル」
        if (text.endsWith('のスタイル')) {
          breadcrumb.textContent = text.replace(
            /のスタイル$/,
            'のスタッフスタイル'
          );
        }
      });

    // 「〇〇の他のスタイリング」→「〇〇の他のスタッフスタイル」
    document
      .querySelectorAll('.pb-app-styledetail-other-coordinate-title')
      .forEach((title) => {
        const text = title.textContent.trim();

        if (text.endsWith('の他のスタイリング')) {
          title.textContent = text.replace(
            /の他のスタイリング$/,
            'の他のスタッフスタイル'
          );
        }
      });
  };

  // 初回
  replaceStaffBoardText();

  // STAFF BOARDの再描画を監視
  const observer = new MutationObserver(() => {
    replaceStaffBoardText();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();

document.addEventListener('DOMContentLoaded', () => {
  const moveRuffRuffBadge = () => {
    const mediaGallery = document.querySelector('.product__media-wrapper media-gallery');

    const mainSlider = mediaGallery?.querySelector(
      ':scope > slider-component.slider-mobile-gutter:not(.thumbnail-slider)'
    );

    const badgeWrapper = document.querySelector(
      'ruffruff-order-bonus-badge-wrapper'
    );

    if (!mainSlider || !badgeWrapper) return false;

    if (!mainSlider.contains(badgeWrapper)) {
      mainSlider.appendChild(badgeWrapper);
    }

    return true;
  };

  if (moveRuffRuffBadge()) return;

  const observer = new MutationObserver(() => {
    if (moveRuffRuffBadge()) {
      observer.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const inquiryRadios = document.querySelectorAll('input[name="contact[問い合わせ項目]"]');
  const orderNumber = document.querySelector('#ContactForm-ordernumber');
  const requiredMark = orderNumber?.closest('.field')?.querySelector('.js-required-mark');

  if (!inquiryRadios.length || !orderNumber) return;

  const updateRequired = () => {
    const selected = document.querySelector('input[name="contact[問い合わせ項目]"]:checked')?.value;
    const isRequired = selected === 'ご注文について';

    if (isRequired) {
      orderNumber.setAttribute('required', '');
      orderNumber.setAttribute('aria-required', 'true');
      requiredMark?.removeAttribute('hidden');
    } else {
      orderNumber.removeAttribute('required');
      orderNumber.removeAttribute('aria-required');
      requiredMark?.setAttribute('hidden', '');
    }
  };

  inquiryRadios.forEach((radio) => {
    radio.addEventListener('change', updateRequired);
  });

  updateRequired();
});